import ReplyPills from '../ReplyPills'

/* eslint-disable import/no-internal-modules */
import TopicPills from '../TopicInfo/TopicPills'

export interface PostMetadataProps {
  publishedAt?: string
  spam: boolean
  pending: boolean
  trashed: boolean
  replyNumber?: number
  replyCount?: number
  pinned?: boolean
  isAuthor?: boolean
}

const PostMetadata = ({ publishedAt, spam, pending, trashed, replyCount, replyNumber, pinned, isAuthor }: PostMetadataProps) => {
  return (
    <header className='clearfix'>
      <span className='text-muted post--time'>
        Posted on {publishedAt}
      </span>
      <div className='pull-right'>
        {replyNumber && replyCount
          ? <ReplyPills trashed={trashed} pending={pending} spam={spam} author={isAuthor} replyCount={replyCount} replyNumber={replyNumber} pinned={pinned} />
          : <TopicPills author spam={spam} pending={pending} trashed={trashed} />}
      </div>
    </header>
  )
}

export default PostMetadata
